import { type FC } from 'react';

import styles from './StatusPill.module.css';

/**
 * What a pill MEANS, not what colour it is.
 *
 * Callers name the meaning and the palette resolves it, so a state that is "this needs
 * attention" looks the same whether it appears on a work order, a batch, or a movement. The
 * alternative — each screen picking its own amber — is how a product ends up with four
 * different warnings.
 */
export type StatusTone = 'neutral' | 'info' | 'warning' | 'positive' | 'critical';

const TONE_CLASS: Record<StatusTone, string> = {
    neutral: styles.neutral,
    info: styles.info,
    warning: styles.warning,
    positive: styles.positive,
    critical: styles.critical,
};

export interface StatusPillProps {
    label: string;
    tone?: StatusTone;
}

/**
 * A small state badge, shared across the product.
 *
 * Lived under containers/workOrders until the manufacturer portal needed the same thing for QC
 * verdicts, movement kinds and provenance. Rather than a second copy diverging from the first,
 * the generic pill moved here and the work-order flavour became a mapping on top of it.
 */
const StatusPill: FC<StatusPillProps> = ({ label, tone = 'neutral' }) => (
    <span className={`${styles.pill} ${TONE_CLASS[tone]}`}>{label}</span>
);

export default StatusPill;
